import { render } from "./Crecimiento.vue?vue&type=template&id=602e68e5&scoped=true"
import script from "./Crecimiento.vue?vue&type=script&lang=js"
export * from "./Crecimiento.vue?vue&type=script&lang=js"

import "./Crecimiento.vue?vue&type=style&index=0&id=602e68e5&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602e68e5"]])

export default __exports__